
import { ref, inject, shallowRef} from 'vue'
import { useRouter, useRoute } from 'vue-router'
import headerMenu from '@/components/header/header.vue'
import { Notify } from 'vant';
import { GetPayFn } from '@/hooks/index'
export default {
  components: {
    headerMenu
  },
  props:{},
  setup(props: object){

    const tabbar_index = 1,
        $http: any = inject('$http'),
        router = useRouter(),
        currencyUnit = ref(''),
        route = useRoute();

    let message = ref('');
    const onCopy = (e: any) => {
        Notify({ type: 'success', message: 'Copy success!' });
    };
    const onError = (e: any) => {
        Notify({ type: 'warning', message: 'The browser does not support automatic replication!' });
    };
    let view_datas: any = ref({}),
        payment_amount = ref('');
    /**
     * 获取需要支付的实际金额
     */
    const get_left_payInfo = async () =>{
        const pay_sn = route.query.pay_sn;
        let param = {
            pay_sn: pay_sn,
        }
        let ret = await $http.get_left_payInfo(param);
        if(ret.code === 200){
            payment_amount.value = ret.data.apiPayAmount;
        }
        else{
            router.push('/')    
        }
    };
    /**
     * 获取页面数据
     */
    const get_mpesa_pay_fn = async () => {
         //获取货币
        const $store: any = inject('$store')
         currencyUnit.value = $store.getSymbol();
        const pay_sn = route.query.pay_sn,
              phone = route.query.phone;
        let paream = {
            pay_sn: pay_sn,
            phone: phone, 
            method: 'OP',
            source: 1
        }
        let ret = await $http.get_pay(paream)
        if(ret.code === 200){
            view_datas.value = ret.data
            message.value = view_datas.value.biz_content ? view_datas.value.biz_content.ofChannels[0].paySN : ''
        }
        else{
            router.push('/')                                                                                   
        }
    };
    //  Init loading datas
    const view_init = () => {
        get_mpesa_pay_fn();
        get_left_payInfo();
    };
    view_init();
    
    /**
     * 收银台支付
     */
    const other_pay_fn = () => {
        const pay_sn = route.query.pay_sn;
        GetPayFn($http, pay_sn);
    }
    const actv_pay_status_fn = () => {
        const pay_sn = route.query.pay_sn;
        router.push(`/status?pay_sn=${pay_sn}`)
    }
    return {
        view_datas,
        actv_pay_status_fn,
        payment_amount,
        message,
        onCopy,
        onError,
        other_pay_fn,
        currencyUnit
    }
  }
}
